import "core-js/stable";

import "regenerator-runtime/runtime";

require("@rails/ujs").start();
import $ from "jquery";